import React from 'react';
import './Skeleton.css';

export function SkeletonBox({ height=16, width='100%', radius=16, className='' }) {
  return <div className={`sk ${className}`} style={{ height, width, borderRadius: radius }} />;
}

export function SkeletonText({ width='100%', height=14 }) {
  return <div className="sk sk--text" style={{ width, height }} />;
}

export function CardSkeleton({ count=1, height=220 }) {
  return <div style={{ display:'grid', gap:16, gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))' }}>{Array.from({ length: count }).map((_, i) => <SkeletonBox key={i} className="sk--card" height={height} />)}</div>;
}
